module.exports = __webpack_public_path__ + "img/add-photo-second-icon-male.908809f9.svg";